import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M21.723 11.984L2.802 3.623l4.68 7.411 14.241.95zm-.066.041l-14.175.945L2.8 20.38l18.857-8.355zm-14.75-.03L1.08 2.769a.5.5 0 0 1 .625-.724l21.5 9.5a.5.5 0 0 1-.01.918L1.7 21.96c-.457.191-.888-.328-.613-.74l5.82-9.225z"
});

var SvgSendEmail = function SvgSendEmail(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgSendEmail;